import { render, staticRenderFns } from "./TabelaDescontosAdicionados.vue?vue&type=template&id=d848ece2&"
import script from "./TabelaDescontosAdicionados.vue?vue&type=script&lang=js&"
export * from "./TabelaDescontosAdicionados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports